import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

/** Apply `hoverReveal` on card wrapper; `tileHover` on tile wrapper (same sheet as `$root`). */
export const useBuyerContentAssetActionsStyles = makeStyles((theme: Theme) => ({
  root: {
    opacity: 0,
    position: 'absolute',
    visibility: 'hidden',
    zIndex: 2,
    transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',
  },
  cardCopilot: {
    alignItems: 'flex-start',
    display: 'flex',
    left: theme.spacing(-3.5),
  },
  cardCopy: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    height: theme.spacing(4),
    justifyContent: 'center',
    opacity: 0.8,
    right: theme.spacing(2),
    top: theme.spacing(2),
    width: theme.spacing(4),
    '& .MuiIconButton-root:hover, & .MuiIconButton-root.Mui-focusVisible': {
      backgroundColor: 'transparent',
    },
  },
  tile: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.25),
    justifyContent: 'flex-end',
    padding: theme.spacing(1.5),
    right: 0,
    top: 0,
    width: '100%',
    '& .MuiIconButton-root': {
      color: theme.palette.common.white,
    },
  },
  hoverReveal: {
    '&:hover $root': {
      opacity: 1,
      visibility: 'visible',
    },
  },
  tileHover: {
    '&:hover $root': {
      opacity: 1,
      visibility: 'visible',
    },
    '&:hover::after': {
      backgroundColor: 'var(--content-overlay-black)',
      bottom: 0,
      content: '""',
      display: 'block',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 1,
    },
  },
}));
